import React from 'react';

import TeamStandingTable from '../../components/Table/TeamStandingTable';


const TeamStanding = () => (
  <div className="content">
    <TeamStandingTable />
  </div>
);

export default TeamStanding;


// WEBPACK FOOTER //
// ./src/pages/TeamStanding/index.js